export default __webpack_public_path__ + "static/media/575.577df79e.png";